<template>
  <div>
    <NtConfirm
      ref="modal"
      level="danger"
      icon="fa-times"
      hide-cancel
      heading="Login Failed"
      confirm-label="Try Again"
      @confirmed="start">
      {{ message }}
    </NtConfirm>
  </div>
</template>

<script>
import Str from 'laravel-js-str'
import NtConfirm from '@/components/general/NtConfirm.vue'
import { mapActions } from 'pinia'
import { useAuthStore } from '../stores/auth'
import { useSystemStore } from '@/stores/system'

export default {
  components: { NtConfirm },
  data() {
    return {
      denied: this.$route.query.error === 'access_denied',
      unauthorized: this.$route.query.error === 'unauthorized',
      failed: null
    }
  },
  computed: {
    message() {
      if (this.denied) {
        return 'You must grant access to your Nurtur account.'
      }
      if (this.unauthorized) {
        return 'Your account does not have access to this system.'
      }

      return this.failed
    }
  },
  mounted() {
    if (this.denied || this.unauthorized) {
      this.$refs.modal.open()
      return
    }

    this.handle()
  },
  methods: {
    ...mapActions(useSystemStore, ['getEnums']),
    ...mapActions(useAuthStore, ['getToken', 'initAuth', 'initLogin']),
    async handle() {
      const state = this.$route.query.state
      const code = this.$route.query.code
      const intended = localStorage.intended || '/'
      if (!code) {
        return this.start(
          this.$route.query.force !== '0' && this.$route.query.referrer !== 'ecosystem',
          this.$route.query.referrer === 'ecosystem'
        )
      }

      try {
        await this.getToken(state, code)
      } catch (e) {
        localStorage.clear()
        this.failed = e.response?.data?.message || e.message || 'Uknown Error'
        this.$refs.modal.open()
        return
      }
      await this.initAuth()

      localStorage.removeItem('intended')
      this.$router.replace(Str.startsWith(intended, '?') ? '/' : intended)
    },
    start(force, direct) {
      return this.initLogin(force || direct)
    }
  }
}
</script>
